<template>
    <h1>Page introuvable</h1>
</template>

<script setup>
</script>

<style>
</style>
